import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { AuthService } from '../service/auth.service';

import { environment } from '@unico-people/shared/utils/environments';
import { SessionStorage } from '@unico-people/shared/utils/storage';

declare global {
  interface Window {
    Cypress: any;
    msw: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  private redirect_uri: string;

  constructor(private auth: AuthService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    if (route?.queryParams?.a) {
      SessionStorage.setItem('redirectAccount', route?.queryParams?.a);
    }

    switch (route?.data?.roles) {
      case 'benefits':
        this.redirect_uri = environment.redirect_uri_benefits;
        break;
      case 'eligibility':
        this.redirect_uri = environment.redirect_uri_benefits + '/eligibility';
        break;
      case 'productivity':
        this.redirect_uri = environment.redirect_uri_benefits + '/productivity';
        break;
      case 'ongoing':
        this.redirect_uri = environment.redirect_uri_ongoing;
        break;
      default:
        break;
    }

    if (!environment?.production && window?.msw) {
      return true;
    }

    if (this.auth.loggedIn()) {
      return true;
    } else {
      let url = await this.auth.startPKCEAuthenticationFlow(this.redirect_uri)
      window.location.href = url

      return false;
    }
  }
}
